export function casinoPlayPath(provider: string, gameCode: string) {
  return `/casino/play?provider=${provider}&gamecode=${gameCode}`
}
